<template>

    <div>
        <b-select :options="teamOptions" :value="value" text-field="name" value-field="id"
            @change="$emit('input', $event)" />
    </div>

</template>

<script lang="ts">
import { Vue, Prop, Component } from "vue-property-decorator";
import axios from "axios";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import { Team } from "@/models/Team";

@Component({
    name: "TeamField",
})
export default class TeamField extends Vue {

    @Prop({ default: null }) value!: number | null;

    protected teams: Team[] = [];

    mounted() {
        this.getTeams();
    }

    async getTeams() {
        try {
            const response = await axios.get<Team[]>("/user/teams");
            this.teams = response.data;
        } catch (err) {
            console.error(err);
            this.$notification(NotificationOptions.error(err));
        }
    }

    get teamOptions() {
        return [
            { name: "", id: null },
            ...this.teams
        ]
    }

}

</script>